import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PortalProveedor } from '@system-dyg/shared/models';

@Injectable({ providedIn: 'root' })
export class PortalProveedoresPersonalizeSession {
  private account: PortalProveedor | null = null;

  set(account: PortalProveedor): void {
    this.account = account;
  }

  get(): PortalProveedor | null {
    return this.account;
  }

  clear(): void {
    this.account = null;
  }
}

export const portalProveedoresPersonalizeGuard: CanActivateFn = () => {
  const session = inject(PortalProveedoresPersonalizeSession);
  const router = inject(Router);
  return session.get() ? true : router.createUrlTree(['/login']);
};
